import { getMetaOgTags } from "./metaOgTags";
import { DomainNameWithSubPathForLocale, GetDomainName } from "~/helpers/UrlHelper";
import { getFormattedCityNames, getFormattedCountryName } from "~/lib/helpers/constants";
import { generateOrganizationLdJson } from "~/lib/helpers/schemaHelper";
import { useRegionConfig } from "~/store/regionConfigStore";
import { workspaceOptions } from "~/components/blocks/common/constants";
import { getCanonicalAndAlternates } from "./canonicalTags";

interface CountryMetaData {
  country: string;
  region?: string;
}

export const officeTypeMeta = ({ data, path }: { data: { country?: CountryMetaData }, path: string }) => {

  const title = `Types of Office Spaces in ${getFormattedCountryName(data?.country)} | Office Hub`;
  const description = `Find coworking, serviced, and private offices across ${getFormattedCityNames(data?.country)}. Explore flexible workspaces that suit your business goals.`;
  const regionConfig = data?.regionData;
  const baseUrl = `${DomainNameWithSubPathForLocale(regionConfig.region)}`;
  const canonicalUrl = `${GetDomainName()}`;
  let Url = canonicalUrl.endsWith("/") && path === "/" ? canonicalUrl.slice(0, -1) : canonicalUrl + (path === "/" ? "" : path);
  const imageUrl = "http://d3ec9r8yaget8k.cloudfront.net/site/assets/banners/area-hero.avif"

  let ldJson = [
    {
      "script:ld+json": {
        "@type": "ItemList",
        "name": "Types of Office Spaces",
        "description": `Office space options available in ${getFormattedCityNames(data?.country)}`,
        "numberOfItems": workspaceOptions.length,
        "itemListElement": workspaceOptions.map((option, i) => ({
          "@type": "ListItem",
          "position": i + 1,
          // "item": { // <-- THIS MUST BE AN OBJECT, NOT AN ARRAY!
          // "@type": "Product",
          "name": option.title,
          "description": option.description,
          "image": option.image,
          "url": `${baseUrl}/${option.link}`,
          "additionalProperty": {
            "@type": "PropertyValue",
            "name": "Features",
            "value": option.features?.length ? option.features.join(", ") : ""
          }
          // "type": "PropertyValue",
          // "name": "Feature",
          // }
        }))
      }
    }
  ];

  return [
    ...getMetaOgTags({ title, description, imageUrl, canonicalUrl: Url }),
    ...generateOrganizationLdJson(baseUrl, description, imageUrl, regionConfig),
    ...ldJson,
    ...getCanonicalAndAlternates(canonicalUrl, path),
  ];
};

